import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';

type SectionContainerProps = {
  renderSettingsForm: () => ReactNode;
  renderPreview: () => ReactNode;
  header?: () => ReactNode;
};

const SectionContainer: FC<SectionContainerProps> = ({
  header,
  renderSettingsForm,
  renderPreview,
}) => {
  return (
    <Container>
      {header && header()}
      <SettingsContainer>{renderSettingsForm()}</SettingsContainer>
      <PreviewContainer>{renderPreview()}</PreviewContainer>
    </Container>
  );
};

export default SectionContainer;

const Container = styled.div`
  border-radius: 12px;
  box-shadow: 0 0 10px #e6e6e6;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
`;

const SettingsContainer = styled.div`
  background-color: #fafafa;
  flex: 3;
  /* s-text-field inputs have almost no intrinsic width (unlike Polaris React's),
     so keep room for the fields and let the preview wrap below instead. */
  min-width: min(100%, 320px);
  height: 100%;
  border-top-left-radius: 12px;
  border-bottom-left-radius: 12px;
`;

const PreviewContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f4f7f9;
  flex: 1;
`;
